<template lang="html">
  <div class="">
    <br>
    <Form ref="form" v-if="form" :label-width="160" @submit.native="post(form)" :model="form" :show-message="false">
      <Row>
        <Col offset="6" span="24"><h2>Modulo {{ (form.code||'').match(/^B/) ? 'Banca' : 'Conto' }}</h2><br><br></Col>
        <template v-if="!form.is_bank">
          <Col span="24"><FormItem label="Tipologia" :rules="req" prop="type">
            <Select v-model="form.type" :disabled="!form.is_custom">
              <Option v-for="t in types" :key="t.type" :value="t.type">{{ t.label }}</Option>
            </Select>
          </FormItem></Col>
          <Col span="24" v-if="types && form.type"><FormItem label="Categoria" :rules="req" prop="category">
            <AutoComplete v-model="form.category" :data="types.find(t => t.type == form.type).categories" :disabled="!form.is_custom"/>
            </FormItem></Col>
            <Col span="24"><FormItem label="Codice" :rules="req" prop="code">
              <Input v-model="form.code" :disabled="!form.is_custom"/>
            </FormItem></Col>
        </template>
        <Col span="24"><FormItem :label="'Nome '+((form.code||'').match(/^B/) ? 'Banca' : 'Conto')" :rules="req" prop="name">
          <Input v-model="form.name"/>
        </FormItem></Col>
        <Col span="24"><FormItem label="Descrizione" prop="description">
          <Input v-model="form.description"/>
        </FormItem></Col>
        <Col span="24" style="text-align:center">
          <FormItem class="">
            <Button type="error" @click="show_form=false; $emit('close')">
              Annulla
            </Button>
            &nbsp;
            <Button type="primary" @click="post(form)">
              Salva
            </Button>
          </FormItem>
        </Col>
        <Col span="24" style="text-align: center">
          <br>
          <br>
          <i>
            Iniziare il codice con "<code>CAS</code>" per renderlo un conto di cassa (es. <code>CAS2</code>).
            <br>
            Iniziare il codice con "<code>B</code>" per renderlo un conto di banca (es. <code>B02</code>).
          </i>
        </Col>
      </Row>
    </Form>

    <Spin size="large" fix v-if="!types"/>
  </div>
</template>

<script>
export default {
  props: [
    'edit',
    'types',
  ],

  data () {
    return {
      form: this.edit ? this._.clone(this.edit) : {},
    }
  },

  methods: {
    post(data) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          data.company_id = this.$store.company.id
          var is_new = !data.id
          this.$http.post('ledgers', data).then(res => {
            this.$emit('close')
            this.$root.$emit('ledgers')
          })
        } else {
          this.$Message.error('Controllare gli errori');
        }
      })
    },
  }
}
</script>

<style lang="css">
</style>
